<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <router-link to="/admin/inbox" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
        <h3>Benachrichtigungsdetails</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="notification-content" v-if="inboxData">
        <div v-if="inboxData.type === 'Produkt-Kontingent hinzugefügt'">
          <span>
            <b>Hallo Admin,</b><br />
            {{ inboxData.message }}. </span
          ><br /><br />
          <div class="row">
            <div class="categoryname-wrapper">
              <div class="room-img-wrapper">
                <img :src="roomImage" alt="" width="100%" />
              </div>
              <div class="room-data-wrapper">
                <h5>{{ productData.product_name }}</h5>

                <span>{{ productData.address }}</span>
              </div>
            </div>
          </div>
          <br /><br />
          <!-- <span>
            <router-link
              target="_blank"
              :to="'/admin/provider-room/' + inboxData.product_id"
              ><b>Hier klicken</b></router-link
            >
            to see the room details.
          </span> -->
        </div>

        <div v-if="inboxData.type === 'Statusänderung des Produktes'">
          <span>
            <b>Hallo Admin,</b><br />
            {{ inboxData.message }} </span
          ><br /><br />
          <div>
            <img :src="roomImage" alt="" width="200px" />
            <div class="room-data-wrapper">
              <h5>{{ productData.product_name }}</h5>
            </div>
            <span
              ><router-link
                target="_blank"
                :to="
                  '/admin/dealer-product-details/' +
                  userData.id +
                  '/' +
                  productData.id
                "
                ><b>Hier klicken</b></router-link
              >
              für Produktdetails</span
            >
            <br /><br />
          </div>
          <v-divider></v-divider>
          <div class="rating-preview-div">
            <b>Händler deatils</b>
            <table class="provider-info-tbl">
              <tr>
                <td>Händler Name:</td>
                <td>{{ userData.first_name + " " + userData.last_name }}</td>
              </tr>
              <tr>
                <td>E-Mail:</td>
                <td>{{ userData.email }}</td>
              </tr>
              <tr>
                <td>Telefonnummer:</td>
                <td>{{ userData.mobile_no ? userData.mobile_no : "-" }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div v-if="inboxData.type == 'Produkt gelöscht'">
          <div class="container">
            <span>
              <b>Hallo Admin,</b><br />
              {{ inboxData.message }} </span
            ><br /><br />
            <div class="rating-preview-div">
              <b>Händler deatils</b>
              <table class="provider-info-tbl">
                <tr>
                  <td>Händler Name:</td>
                  <td>{{ userData.first_name + " " + userData.last_name }}</td>
                </tr>
                <tr>
                  <td>E-Mail:</td>
                  <td>{{ userData.email }}</td>
                </tr>
                <tr>
                  <td>Telefonnummer:</td>
                  <td>{{ userData.mobile_no ? userData.mobile_no : "-" }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>

        <div
          v-if="
            inboxData.type == 'Ein neues Produkt wurde vom Händler hinzugefügt'
          "
        >
          <div>
            <span>
              <b>Hallo Admin,</b><br />
              {{ inboxData.message }} </span
            ><br /><br />
          </div>
          <div>
            <img :src="roomImage" alt="" width="200px" />
            <div class="room-data-wrapper">
              <h5>{{ productData.product_name }}</h5>
            </div>
            <span
              ><router-link
                target="_blank"
                :to="
                  '/admin/dealer-product-details/' +
                  userData.id +
                  '/' +
                  productData.id
                "
                ><b>Hier klicken</b></router-link
              >
              für Produktdetails</span
            >
            <br /><br />
          </div>
          <v-divider></v-divider>
          <div class="rating-preview-div">
            <b>Händler deatils</b>
            <table class="provider-info-tbl">
              <tr>
                <td>Händler Name:</td>
                <td>{{ userData.first_name + " " + userData.last_name }}</td>
              </tr>
              <tr>
                <td>E-Mail:</td>
                <td>{{ userData.email }}</td>
              </tr>
              <tr>
                <td>Telefonnummer:</td>
                <td>{{ userData.mobile_no ? userData.mobile_no : "-" }}</td>
              </tr>
            </table>
          </div>
        </div>

        <div
          v-if="
            inboxData.type == 'Handler geändert Produktname'
          "
        >
          <div>
            <span>
              <b>Hallo Admin,</b><br />
              {{ inboxData.message }} </span
            ><br /><br />
          </div>
          <div>
            <img :src="roomImage" alt="" width="200px" />
            <div class="room-data-wrapper">
              <h5>{{ productData.product_name }}</h5>
            </div>
            <span
              ><router-link
                target="_blank"
                :to="
                  '/admin/dealer-product-details/' +
                  userData.id +
                  '/' +
                  productData.id
                "
                ><b>Hier klicken</b></router-link
              >
              für Produktdetails</span
            >
            <br /><br />
          </div>
          <v-divider></v-divider>
          <div class="rating-preview-div">
            <b>Händler deatils</b>
            <table class="provider-info-tbl">
              <tr>
                <td>Händler Name:</td>
                <td>{{ userData.first_name + " " + userData.last_name }}</td>
              </tr>
              <tr>
                <td>E-Mail:</td>
                <td>{{ userData.email }}</td>
              </tr>
              <tr>
                <td>Telefonnummer:</td>
                <td>{{ userData.mobile_no ? userData.mobile_no : "-" }}</td>
              </tr>
            </table>
          </div>
        </div>
        <!-- Added this section for type Handler geändert Produktbeschreibung on 15-06-2026-->
        <div
          v-if="
            inboxData.type == 'Handler geändert Produktbeschreibung'
          "
        >
          <div>
            <span>
              <b>Hallo Admin,</b><br />
              {{ inboxData.message }} </span
            ><br /><br />
          </div>
          <div>
            <img :src="roomImage" alt="" width="200px" />
            <div class="room-data-wrapper">
              <h5>{{ productData.product_name }}</h5>
              <div v-if="!descriptionExpanded" class="product-description-text">
                {{ previewDescription }}
              </div>
              <div v-else class="product-description-text" v-html="notificationDescription"></div>
              <button
                v-if="hasLongDescription"
                type="button"
                class="read-more-btn"
                @click="toggleDescription"
              >
                {{ descriptionExpanded ? 'Weniger anzeigen' : 'Mehr lesen' }}
              </button>
            </div>
            <span
              ><router-link
                target="_blank"
                :to="
                  '/admin/dealer-product-details/' +
                  userData.id +
                  '/' +
                  productData.id
                "
                ><b>Hier klicken</b></router-link
              >
              für Produktdetails</span
            >
            <br /><br />
          </div>
          <v-divider></v-divider>
          <div class="rating-preview-div">
            <b>Händler deatils</b>
            <table class="provider-info-tbl">
              <tr>
                <td>Händler Name:</td>
                <td>{{ userData.first_name + " " + userData.last_name }}</td>
              </tr>
              <tr>
                <td>E-Mail:</td>
                <td>{{ userData.email }}</td>
              </tr>
              <tr>
                <td>Telefonnummer:</td>
                <td>{{ userData.mobile_no ? userData.mobile_no : "-" }}</td>
              </tr>
            </table>
          </div>
        </div>
<!-- Added this section for type Handler geändert Produktbeschreibung on 15-06-2026-->
        <div v-if="inboxData.type == 'Neue Registrierung eines Händlers'">
          <div>
            <span>
              <b>Hallo Admin,</b><br />
              {{ inboxData.message }} </span
            ><br /><br />
          </div>
          <v-divider></v-divider>
          <div class="rating-preview-div">
            <b>Händler details</b>
            <table class="provider-info-tbl">
              <tr>
                <td>Händler Name:</td>
                <td>{{ userData.first_name + " " + userData.last_name }}</td>
              </tr>
              <tr>
                <td>E-Mail:</td>
                <td>{{ userData.email }}</td>
              </tr>
              <tr>
                <td>Telefonnummer:</td>
                <td>{{ userData.mobile_no ? userData.mobile_no : "-" }}</td>
              </tr>
            </table>
          </div>
        </div>

        <div v-if="inboxData.type == 'Neue Registrierung eines Kunden'">
          <div>
            <span>
              <b>Hallo Admin,</b><br />
              {{ inboxData.message }} </span
            ><br /><br />
          </div>
          <v-divider></v-divider>
          <div class="rating-preview-div">
            <b>Kunden details</b>
            <table class="provider-info-tbl">
              <tr>
                <td>Kundenname:</td>
                <td>{{ userData.first_name + " " + userData.last_name }}</td>
              </tr>
              <tr>
                <td>E-Mail:</td>
                <td>{{ userData.email }}</td>
              </tr>
              <tr>
                <td>Telefonnummer:</td>
                <td>{{ userData.mobile_no ? userData.mobile_no : "-" }}</td>
              </tr>
            </table>
          </div>
        </div>

        <div v-if="inboxData.type == 'Support-Nachricht'">
          <div>
            <span>
              <b>Hallo Admin,</b><br />
              {{ inboxData.message }} </span
            ><br /><br />
          </div>
          <v-divider></v-divider>
          <h5>Nachricht</h5>
          <div v-html="supportDetails.message"></div>

          <v-btn
            @click="goToSupportReply(inboxData.support_id)"
            class="no-button"
            >Antwort senden</v-btn
          >
          <v-divider></v-divider>
          <div class="rating-preview-div">
            <b>Händler details</b>
            <table class="provider-info-tbl">
              <tr>
                <td>Händler Name:</td>
                <td>{{ userData.first_name + " " + userData.last_name }}</td>
              </tr>
              <tr>
                <td>E-Mail:</td>
                <td>{{ userData.email }}</td>
              </tr>
              <tr>
                <td>Telefonnummer:</td>
                <td>{{ userData.mobile_no ? userData.mobile_no : "-" }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div v-if="inboxData.type == 'Support Antwort'">
          <div>
            <span>
              <b>Hallo Admin,</b><br />
              {{ inboxData.message }} </span
            ><br /><br />
          </div>
          <v-divider></v-divider>
          <h5>Nachricht</h5>
          <div v-html="supportDetails.message"></div>

          <v-btn
            @click="goToSupportReply(inboxData.support_id)"
            class="no-button"
            >Antwort senden</v-btn
          >
          <v-divider></v-divider>
          <div class="rating-preview-div">
            <b>Händler details</b>
            <table class="provider-info-tbl">
              <tr>
                <td>Händler Name:</td>
                <td>{{ userData.first_name + " " + userData.last_name }}</td>
              </tr>
              <tr>
                <td>E-Mail:</td>
                <td>{{ userData.email }}</td>
              </tr>
              <tr>
                <td>Telefonnummer:</td>
                <td>{{ userData.mobile_no ? userData.mobile_no : "-" }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div v-if="inboxData.type == 'Handler geändert Produktbild'">
          <div>
            <span>
              <b>Hallo Admin,</b><br />
              {{ inboxData.message }} </span
            ><br /><br />
          </div>
          <v-divider></v-divider>
          <div>
            <img :src="roomImage" alt="" width="200px" />
            <div class="room-data-wrapper">
              <h5>{{ productData.product_name }}</h5>
            </div>
            <span
              ><router-link
                target="_blank"
                :to="
                  '/admin/dealer-product-details/' +
                  userData.id +
                  '/' +
                  productData.id
                "
                ><b>Hier klicken</b></router-link
              >
              für Produktdetails</span
            >
            <br /><br />
          </div>
          <v-divider></v-divider>
          <div class="rating-preview-div">
            <b>Händler details</b>
            <table class="provider-info-tbl">
              <tr>
                <td>Händler Name:</td>
                <td>{{ userData.first_name + " " + userData.last_name }}</td>
              </tr>
              <tr>
                <td>E-Mail:</td>
                <td>{{ userData.email }}</td>
              </tr>
              <tr>
                <td>Telefonnummer:</td>
                <td>{{ userData.mobile_no ? userData.mobile_no : "-" }}</td>
              </tr>
            </table>
          </div>
        </div>

        <div v-if="inboxData.type == 'new room confirmed'">
          <h2>new room confirmed</h2>
        </div>
        <div v-if="inboxData.type == 'Booking'">
          <div class="row">
            <div class="col-md-6">
              <span>
                <b>Hello Admin,</b><br />
                The customer
                {{ userData.first_name + " " + userData.last_name }} has
                requested booking for the room
                <b>"{{ productData.product_name }}"</b>. </span
              ><br /><br />
              <span>
                <router-link
                  target="_blank"
                  :to="'/admin/booking/' + bookingData_id"
                  ><b>Hier klicken</b></router-link
                >
                to see the booking details.
              </span>
            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="categoryname-wrapper">
                  <div class="room-img-wrapper">
                    <img :src="roomImage" alt="" width="100%" />
                  </div>
                  <div class="room-data-wrapper">
                    <h5>{{ productData.product_name }}</h5>
                    <h6>{{ categoryName }}</h6>
                    <span>{{ productData.address }}</span>
                  </div>
                </div>
              </div>
              <v-divider></v-divider>
              <span>Booking Dates</span>
              <table class="provider-info-tbl mb-5">
                <tr>
                  <td>Check in</td>
                  <td>{{ bookingData.check_in }}</td>
                </tr>
                <tr>
                  <td>Check out</td>
                  <td>{{ bookingData.check_out }}</td>
                </tr>
              </table>
              <v-divider></v-divider>
              <span>Customer Details</span>
              <table class="provider-info-tbl mb-5">
                <tr>
                  <td>Name:</td>
                  <td>
                    {{
                      inboxData.users.first_name +
                      " " +
                      inboxData.users.last_name
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Email:</td>
                  <td>{{ inboxData.users.email }}</td>
                </tr>
                <tr>
                  <td>Contact:</td>
                  <td>
                    {{
                      inboxData.users.mobile_no
                        ? inboxData.users.mobile_no
                        : "-"
                    }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center" v-else>
        <span>Something went wrong.</span>
      </div>
    </div>

    <notifications group="inbox" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import Notifications from "vue-notification";
import JwtService from "@/core/services/jwt.service";
import HtmlClass from "@/core/services/htmlclass.service";
import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
import Loader from "@/components/admin/layout/Loader.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import adminAPI from "@/api/admin";
Vue.use(Notifications);
export default {
  name: "Inbox",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      // show page loading
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      this.getNotification();
    }
  },
  mounted() {
    let array = [];
    array.push(this.$route.params.id);
    adminAPI.readStatusUpdate({ id: array });
  },
  data() {
    return {
      inboxData: [],
      postpones: [],
      users: [],
      userData: [],
      productData: [],
      bookingData: [],
      roomImage: "",
      searchNameKey: "",
      searchCategoryKey: "",
      loading_inboxData: true,
      supportDetails: [],
      rating: [],
      categoryName: "",
      filter: {
        orderCol: "id",
        orderBy: "desc",
      },
      pagination: {
        currentPage: 1,
        perPage: 20,
        paginationRows: "",
      },
    };
  },
  methods: {
    goToSupportReply(id) {
      let encodedId = btoa(btoa(id));
      this.$router.push({ path: "/admin/support-response/" + encodedId });
    },
    goToDetails(id) {
      this.$router.push({ path: "/admin/inbox/" + id });
    },
    paginationChange() {
      this.blogs = [];
      this.loading_inboxData = true;
      setTimeout(() => {
        this.getBlogs();
      }, 100);
    },
    getNotification() {
      adminAPI
        .getNotification({ id: [parseInt(this.$route.params.id)] })
        .then((response) => {
          if (response.status == "success") {
            this.inboxData = response.data[0];
            if (this.inboxData.type == "Support-Nachricht" || this.inboxData.type == "Support Antwort") {
              this.supportDetails = this.inboxData.support_detail;
            }
            if (response.data[0].booking) {
              this.bookingData = response.data[0].booking;
            }
            if (response.data[0].users) {
              this.userData = response.data[0].users;
            }
            if (response.data[0].product_detail) {
              this.productData = response.data[0].product_detail;
              this.roomImage =
                response.data[0].product_detail.pictures[0].photo_path;
            }
            if (response.data[0].rating) {
              this.rating = response.data[0].rating;
            }
            this.loading_inboxData = false;
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          } else {
            this.loading_inboxData = false;
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.$notify({
              group: "inbox",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.loading_inboxData = false;
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.$notify({
            group: "inbox",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 5000,
          });
        });
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.invite-btn {
  background-color: #3d5a80 !important;
}

.invite-btn:hover {
  background-color: #002c47 !important;
}

.new-btn-text {
  margin-left: 10px;
  font-size: 13px;
}

a {
  cursor: pointer;
}

.file-modal {
  padding: 0;
  margin: 0;
}

.modal-image {
  width: 100%;
}

.table-image {
  cursor: pointer;
  margin: 5px;
}

th {
  cursor: pointer;
}

.loading-tbody {
  text-align: center;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px;
  height: 48px;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 14px;
  height: 48px;
}

.clickable-td {
  cursor: pointer;
}
</style>